export default "__VITE_ASSET__Ou0Y04VD__"